import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { ITag } from "@common/interfaces/tag";
import { EntityState, EntityStore } from "@datorama/akita";

export interface TagState extends EntityState<ITag, string> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.TAGS , realtimeEntity: 'Tag'})
export class TagStore extends EntityStore<TagState> {
  constructor() {
    super([]);
  }
}
